import {Injectable} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DatePipe} from '@angular/common';
import {ApplicationLogVoModel} from './application-log-vo.model';

const apiPrefix = `/analytics/v1/`;

const routes = {
    addNewApplicationLog: () => apiPrefix + `logs`,
    getApplicationLogs: (page: number, size: number) => apiPrefix + `filtered-logs?&page=${page}&size=${size}`,
    getUserActions: () => apiPrefix + `user-actions`,
    getPageTitles: () => apiPrefix + `page-titles`,
    downloadLogs: () => apiPrefix + `filtered-logs-download`
};

@Injectable({
    providedIn: 'root'
})


export class ApplicationAnalyticsService {

    constructor(private http: HttpClient) {
    }

    getFilteredApplicationRoute(applicationLogFilterModel: any, page: number = 0, size: number = 10) {
        const datePipe = new DatePipe('en-US');
        applicationLogFilterModel.fromLogDateTime =
            datePipe.transform(applicationLogFilterModel.fromLogDateTime, 'yyyy-MM-dd\'T\'HH:mm:ss');
        applicationLogFilterModel.toLogDateTime = datePipe.transform(applicationLogFilterModel.toLogDateTime, 'yyyy-MM-dd\'T\'HH:mm:ss');
        const $applicationLogs: Observable<any> = this.http.post(routes.getApplicationLogs(page, size), applicationLogFilterModel)
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $applicationLogs;
    }

    getUserActions() {
        const $userAction: Observable<any> = this.http
            .get(routes.getUserActions())
            .pipe(
                map((x) => {
                    return x as any;
                })
            );
        return $userAction;
    }

    logAnalytics(applicationLogVO: ApplicationLogVoModel) {
        const datePipe = new DatePipe('en-US');
        const loggedInUser = JSON.parse(localStorage.getItem('logged-in-user'));
        applicationLogVO.logDateTime = datePipe.transform(Date.now(), 'yyyy-MM-dd\'T\'HH:mm:ss');
        applicationLogVO.roles = loggedInUser?.roles ? loggedInUser?.roles : null;
        applicationLogVO.firstName = loggedInUser?.firstName ? loggedInUser?.firstName : null;
        applicationLogVO.lastName = loggedInUser?.lastName ? loggedInUser?.lastName : null;
        applicationLogVO.userBusinessEntities = loggedInUser?.businessEntities?.length > 0 ?
            loggedInUser?.businessEntities?.map((x) => {
                return {
                    entityName: x?.name,
                    entityId: x?.businessEntityId
                };
            }) : [];
        applicationLogVO.userDomains = loggedInUser?.domains?.length > 0 ? loggedInUser?.domains : [];
        applicationLogVO.emailId = loggedInUser?.username ? loggedInUser?.username : null;


        this.http
            .post(routes.addNewApplicationLog(), applicationLogVO)
            .toPromise()
            .then();
    }

    getPageTitles() {
        const $pageTitles: Observable<any> = this.http
            .get(routes.getPageTitles())
            .pipe(map((x) => {
                return x as any;
            }));
        return $pageTitles;
    }

    downloadApplicationLogs(applicationLogFilterModel: any) {
        const $logs: Observable<any> = this.http
            .post(routes.downloadLogs(), applicationLogFilterModel)
            .pipe(
                map((res) => res as any)
            )
        ;
        return $logs;
    }
}
